(function () {
    "use strict";

    // @ngInject
    function CoreControllerCtor($scope, $injector, $log, $timeout, $window, Gon,$document,
                                OnboardingService, ModalService, UiPersistenceService,
                                UsersManager, WebsocketHelperService, AppConfigService, $stateParams, NavigationService, DeviceService, FacebookPixelTrackingService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CoreController';
        this.OnboardingService = OnboardingService;
        this.persistenceHash = null;
        this.NavigationService = NavigationService;
        this.UsersManager = UsersManager;
        this.FacebookPixelTrackingService = FacebookPixelTrackingService;
        this.$log = $log;
        this.currUser = null;
        this.WebsocketHelperService = WebsocketHelperService;
        this.window = $window;
        this.DeviceService = DeviceService;
        var checkifMobileAndroid = this.DeviceService.isAndroid();
        var currUser = UsersManager.getCurrUser();
        this.isScrolled = false;
        this.enableHotReloading = window.enableHotReloading;

        this.isAndroidMobile = false;
        if(checkifMobileAndroid){
            this.isAndroidMobile = true;
        }

        var _this = this;

        this.checkIfTrialExpired = function setOnboarding() {
            var currUser = UsersManager.getCurrUser();
            if (currUser && currUser._id) {
                var callback = function () {
                    $timeout(function () {
                        // we handle the persistence only when we can relay on te fact that we have a user logged in
                        // sometime this event happens to early when the persistency service is not updated yet.
                        // for things we want to show the user right at the beginning.
                        this.persistenceHash = UiPersistenceService.getUiPersistence(UiPersistenceService.keys.coreControllerPersistence,
                            {hideExpiredTrialModal: false});

                        if (currUser.hasTrialExpiredDueToNoPayment() && !this.persistenceHash.hideExpiredTrialModal) {
                            ModalService.openTrialExpiringModal(true);
                            this.persistenceHash.hideExpiredTrialModal = true;
                            UiPersistenceService.setUiPersistence(UiPersistenceService.keys.coreControllerPersistence, this.persistenceHash);
                        } else if (currUser.trial_extension_data) {
                            if (currUser.trial_extension_data.is_extended && currUser.trial_extension_data.extension_reason === "retargeting_ad" &&
                                currUser.trial_extension_data.extension_type === "days" && currUser.trial_extension_data.extension_amount) {
                                ModalService.openTrialExtendedModal(currUser.trial_extension_data.extension_amount);
                            }
                            delete currUser.trial_extension_data; //clear from curr user object
                        }
                    }.bind(this), 500);
                }.bind(this);

                UsersManager.checkForTrialExtension(currUser).then(callback).catch(callback); //should've used finally but not supported on IE & Edge
            }
        }.bind(this);

        this.registerToCompanyModel = function registerToCompanyModel() {
            var currUser = UsersManager.getCurrUser();
            if(currUser && currUser._id) {
                this.unregisterCompanyModel();
                this.currUser = currUser;
                this.register(this.currUser.company, 'success', function handleCompanyModelUpdated(){
                    this.checkIfTrialExpired();
                }.bind(this));
            }
        };

        this.trackPixel = function trackPixel() {
            var currUser = UsersManager.getCurrUser();
            if (currUser && currUser._id) {
                this.FacebookPixelTrackingService.trackCustomOnDesktopIfStartedMobile(currUser, 'MobileOnDesktop', {'currency': 'USD', 'value': 0});
            }
        };

        this.trackPixel();
        this.FacebookPixelTrackingService.track('PageView');

        this.unregisterCompanyModel = function unregisterCompanyModel() {
            if (this.currUser && this.currUser.company) {
                this.unregister(this.currUser.company);
            }
            this.currUser = null;
        };

        this.registerToCompanyModel();

        UsersManager.on('loggingOut', function handleLoggingOut() {
            this.checkIfTrialExpired();
            this.persistenceHash = null;
            this.unregisterCompanyModel();
        }.bind(this));

        UsersManager.on('loggingIn', function handleLoggingIn() {
            this.checkIfTrialExpired();
            this.registerToCompanyModel();
            this.trackPixel();
        }.bind(this));

        UsersManager.on('resetPsw', function handleLoggingIn() {
            this.checkIfTrialExpired();
            this.registerToCompanyModel();
        }.bind(this));

        // emitted from second level nav, rebroadcast down for people clients
        $scope.$on('emitContactsAdded', function(event, data) {
            this.$scope.$broadcast('broadcastContactsAdded', data);
        }.bind(this));

        $(window).on('scroll', function() {
            if (this.pageYOffset > 0) {
                $('body').addClass('page-is--scrolled');
            } else {
                $('body').removeClass('page-is--scrolled');
            }
        });
    }

    Controllers.CoreController = Class(Controllers.BaseController, {

        constructor: CoreControllerCtor,

        isRouteActive: function isRouteActive(root) {
            return this.$state.current.name && this.$state.current.name.indexOf(root) !== -1;
        },

        goToLoansTab: function goToLoansTab() {
            this.goToState(this.AppStates.root_core_navigation_loans);
        },

        dismissLoanOffer: function dismissLoanOffer() {
            this.UsersManager.dismissLoanOffer();
        }
    });
}());
